import React from 'react';

export const TemplateSelector = ({ onSelect }) => (
    <div style={{display: "flex", justifyContent: "center"}}>
        <button onClick={() => onSelect('Team')} className="btn btn-lg btn-success m-2">Team</button>
        <button onClick={() => onSelect('Education')} className="btn btn-lg btn-primary m-2">Education</button>
    </div>
);
